module.exports = __webpack_public_path__ + "static/media/bg_CrossCarro.910b56b7.jpg";